module.exports = __webpack_public_path__ + "img/abstract_select.4ae461e1.svg";